import HttpStatus from 'http-status-codes';
import { post } from 'axios';

const addQueryToUrl = (url, queryHash) => {
  let urlWithParams = url;
  if (queryHash) {
    urlWithParams += '?';
    Object.keys(queryHash).forEach(function(key) {
      urlWithParams += `${key}=${queryHash[key]}&`;
    });
    urlWithParams = urlWithParams.replace(/&\s*$/, '');
  }
  return urlWithParams;
};

const setRequestHeader = (headers, request) => {
  Object.entries(headers || {}).map(([headerName, value])=>{
    if (!headerName || !value) return;
    request.setRequestHeader(headerName, value, false);
  });
};

const http = {
  get: function(url, options = {}) {
    return new Promise(function(resolve, reject) {
      const request = new XMLHttpRequest();
      request.open('GET', url);
      request.withCredentials = options.withCredentials || false;

      const { headers } = options;
      setRequestHeader(headers, request);

      request.send(null);
      request.onload = function() {
        if (request.readyState === XMLHttpRequest.DONE) {
          if (request.status === HttpStatus.OK) {
            resolve(request.responseText);
          } else {
            reject(new Error(`Network Request Failed: ${request.status} - ${request.statusText}`));
          }
        } else {
          reject(new Error('XMLHttpRequest did not finish'));
        }
      };
    });
  },
  post: function(url, payload, options = {}) {
    const urlWithParams = addQueryToUrl(url, options.registrationOptions);
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      ...options.headers
    };
    const config = {
      headers,
      responseType: 'json',
      withCredentials: options.withCredentials || false
    };
    return post(urlWithParams, payload, config);
  }
};

export default http;
